import React, { useContext, useEffect, useState } from "react";
import DoubleButton from "../Button/DoubleButton";
import { PiUploadBold } from "react-icons/pi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { TbNotes } from "react-icons/tb";
import { BsFilePerson } from "react-icons/bs";
import { FiInfo, FiUserCheck } from "react-icons/fi";
import employerContext from "../../hooks/employerContext";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { IoIosInformationCircleOutline, IoMdCheckmark } from "react-icons/io";
import Cookies from "js-cookie";




const CardWithCard = ({
    cardTitle,
    cardDate,
    cardDateClassName,
    cardParaTestId,
    firstButton_Name,
    secondButton_Name,
    icon,
    firstCardColor,
    secondCardColor,
    cardTitleStyle,
    cardKey,
    anotherPageUrl,
    viewed,
    applied,
    notReviewed,
    shortlisted,
    jobId,
    dropDownName,
    handleOpenJob,
    handleCloseJob,
    handlePauseJob,
    handleCandidateSearchRadioButton,
    getAppliedCandidateSearch,
    candidateDetailsDb,
    setCandidateDetailsDb,
    radioValueDb,
    setRadioValueDb,
    setcandidateNameDb,
    candidateFeedbackDb,
    setCandidateFeedbackDb,
    handleCandidateFeedbackDb,
    appliedCandidates,
    setAppliedCandidates,
    setClosingCandidateDetails,
    openValue,
    handleJobDelete,
    remainingDays,
    extendValidityPost,
    assigned_user_name,
    setAssignJobModel,
    cardData,
    setAssignJobModelData,
    setAssignJobModelEditData,
    setAssignJobValidation,
    setJobAssignSpinner, job_closed_status_flag

}) => {
    const { setPageThreeSkillDataResponse, getJobApi, setHomeResponseReview, setCreateJobId, setExistingTemplate, displayStep, setShowReview, setShowProgressBar, setShowFieldOne, setShowFieldTwo, setShowFieldThree, setShowFieldFour,
        setProgressBarHide, pageFourJobDetails, setPageFourJobDetails,
        setEditingJobFromHome, getCandidateDatas, setSendingCandidate, setJobListContent, setRoleStatus, setEditingJobStatus,
        // Pricing
        country
    } = useContext(employerContext);

    const pageRender = useNavigate();
    const [isHoveredCardKey, setIsHoveredCardKey] = useState(false)

    const handleRedirectToReview = (id) => {
        var redirectingValue = getJobApi.filter((v) => {
            return v.id === id
        })
        if (redirectingValue.length > 0) {
            var questionArray = redirectingValue[0].question_list.map((v) => {
                return v.custom_pre_screen_ques
            })

            const contentFour = {
                ...pageFourJobDetails,
                questions: questionArray,
                resume: redirectingValue[0].required_resume,
                coverLetter: redirectingValue[0].required_cover_letter,
                receive_notification: redirectingValue[0]?.receive_notification,
            }
            setPageFourJobDetails(contentFour)

            setShowProgressBar(false)
            setExistingTemplate(true)
            setHomeResponseReview(true)
            setCreateJobId(...redirectingValue)

            setShowReview(false)
            setShowFieldOne(false);
            setShowFieldTwo(false);
            setShowFieldThree(false);
            setShowFieldFour(true);

            pageRender("/employer_dashboard/multistepForm")
        } else {
            toast.error("Data not found")
        }
    }

    const handleRedirectToEditAndReview = (id, openValue) => {
        setEditingJobStatus(openValue)
        var redirectingValue = getJobApi.filter((v) => {
            return v.id === id
        })

        if (redirectingValue.length > 0) {
            var questionArray = redirectingValue[0].question_list.map((v) => {
                return v.custom_pre_screen_ques
            })

            const contentFour = {
                ...pageFourJobDetails,
                questions: questionArray,
                resume: redirectingValue[0].required_resume,
                coverLetter: redirectingValue[0].required_cover_letter,
                receive_notification: redirectingValue[0]?.receive_notification,
            }
            setPageFourJobDetails(contentFour)

            setEditingJobFromHome(true)
            setShowProgressBar(true)
            setExistingTemplate(true)
            setHomeResponseReview(true)
            setCreateJobId(...redirectingValue)
            setShowReview(false)
            setProgressBarHide(true)
            pageRender("/employer_dashboard/multistepForm")
            displayStep(4)
        } else {
            toast.error("Data not found")
        }
    }

    const handleRedirectToCandidate = (id) => {
        setSendingCandidate(true)
        var roleValue = openValue[0].toUpperCase() + openValue.slice(1);

        getCandidateDatas(id, "changeRole", undefined, roleValue)
        pageRender('/employer_dashboard/candidates')
    }

    const handleExtendedValidity = () => {
        document.getElementById(`extendedValidity${jobId}ModalCloseButton`).click()
        pageRender('/employer_dashboard/pricing-plan')
    }


    return (
        <div className="card shadow-sm bg-body rounded-4 border-0 overflow-hidden employer-job-details pb-3 h-100"
            key={cardKey} id={jobId}
        >
            {/* <div className=" "> */}
            <div className="body-head card-header bg-transparent border-0 p-0 pt-2 px-sm-4 px-2">
                <div className={`employer-details-head ${assigned_user_name ? "pt-5 position-relative" : "pt-4"}`}>
                    <h5 className={`card-title ${cardTitleStyle} fw-bold ps-2 pe-4 `}
                        data-testid="cardHeadingTestId">  {cardTitle.length > 32 ? `${cardTitle.slice(0, 32)}..` : cardTitle}
                    </h5>

                    <p id={`employerThreeDotsMenu${jobId}Icon`}
                        className={`cursorPointer threeDotsMenu ${assigned_user_name ? "pt-4" : "pt-2"}`}
                        data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <BsThreeDotsVertical />
                    </p>

                    {
                        assigned_user_name ?
                            <div className='d-inline-flex employerHomeCardBadge'>
                                <div className={`py-2 px-3 me-1 orange_bg_badge w-100`}>
                                    <p className='m-0'>
                                        <span className="apply-job-brand-color pe-2">Managed by :</span>
                                        {assigned_user_name}
                                    </p>
                                </div>
                            </div>
                            :
                            null
                    }

                    <div className="dropdown custom-dropdown w-50">
                        <ul className="dropdown-menu w-100 border-0 shadow">
                            <li
                                className="cursorPointer"
                                id={`employerViewJobPost${jobId}Button`}
                                onClick={() => handleRedirectToReview(jobId)}
                            >
                                <a className="dropdown-item fw-medium">View job details</a>
                            </li>
                            <hr className="m-0 mx-3 buttonLineColor" />
                            {openValue === "closed" ? (
                                <li
                                    className="cursorPointer"
                                    id={`employerDeleteJobPost${jobId}Button`}
                                    onClick={(e) => {
                                        handleJobDelete(e, jobId);
                                        setPageThreeSkillDataResponse();
                                    }}
                                >
                                    <a className="dropdown-item fw-medium">Delete job post</a>
                                </li>
                            ) : remainingDays === 0 ? (
                                <li>
                                    <a className="dropdown-item fw-medium pe-none">Edit job post</a>
                                </li>
                            ) : (
                                <li
                                    className="cursorPointer"
                                    id={`employerEditJobPost${jobId}Button`}
                                    onClick={() => {
                                        handleRedirectToEditAndReview(jobId, openValue);
                                        setPageThreeSkillDataResponse();
                                    }}
                                >
                                    <a className="dropdown-item fw-medium">Edit job post</a>
                                </li>
                            )}

                            {openValue === "opened" && Cookies.get("user_role") && Cookies.get("user_role") !== "recruiter" ? (
                                <li
                                    className={`cursorPointer ${["premium", "platinum"].includes(Cookies.get("pricing_category")?.toLowerCase()) ? '' : 'opacity-50'}`}
                                    id={`employerAssignJobPost${jobId}Button`}
                                    onClick={
                                        ["premium", "platinum"].includes(Cookies.get("pricing_category")?.toLowerCase())
                                            ? () => {
                                                setAssignJobModel(true);
                                                setAssignJobModelData(cardData);
                                                setAssignJobValidation(false);
                                                setJobAssignSpinner(false);
                                                setAssignJobModelEditData({});
                                            }
                                            : null
                                    }
                                    onMouseEnter={() => setIsHoveredCardKey(cardKey)}
                                    onMouseLeave={() => setIsHoveredCardKey(null)}
                                >
                                    <a className={`dropdown-item fw-medium`} >
                                        Assign Job
                                        {!["premium", "platinum"].includes(Cookies.get("pricing_category")?.toLowerCase()) ?
                                            <span className={`${isHoveredCardKey === cardKey ? "text-light" : "text-secondary"} ps-4`} >
                                                <FiInfo size={17} />
                                            </span>
                                            :
                                            null
                                        }
                                    </a>



                                </li>
                            ) : null}
                        </ul>
                        {!["premium", "platinum"].includes(Cookies.get("pricing_category")?.toLowerCase()) ?
                            <div className="ps-2 w-5">
                                {isHoveredCardKey === cardKey && (
                                    <div className="info-hover-text-assign-job bg-secondary-subtle p-1 mt-3 px-2">
                                        Upgrade to unlock the ability to add users and assign jobs
                                    </div>
                                )}
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
                <p
                    className={`card-date-text ${cardDateClassName} ps-2`}
                    data-testid={cardParaTestId} >Posted on {cardDate} </p>
            </div>
            <div className="card-body p-1 p-sm-4">
                {/* Applied viewed notReviewed and shortlisted */}
                <div className="body-content">
                    <div className="row row-cols-2 row-cols-sm-2 g-2">
                        <Fourcards empIcon={<PiUploadBold />} profNum={viewed} empReview={"Viewed"} />
                        <Fourcards empIcon={<TbNotes />} profNum={applied} empReview={"Applied"} />
                        <Fourcards empIcon={<BsFilePerson />} profNum={notReviewed} empReview={"Not Reviewed"} />
                        <Fourcards empIcon={<FiUserCheck />} profNum={shortlisted} empReview={"Shortlisted"} />
                    </div>
                </div>
                <hr className="mt-4 mb-1" />
            </div>

            <div className="card-footer bg-transparent border-0 p-0 mx-4 mb-2">
                <DoubleButton
                    firstButtonName={firstButton_Name}
                    secondButtonName={secondButton_Name}
                    cardIcon={icon}
                    firstCardColorclassName={firstCardColor}
                    secondCardColorclassName={secondCardColor}
                    rightCommUrl={anotherPageUrl}
                    dropDownName={dropDownName}
                    handlePause={handlePauseJob}
                    handleOpen={handleOpenJob}
                    handleClose={handleCloseJob}
                    jobId={jobId}
                    handleCandidateRadioButton={handleCandidateSearchRadioButton}
                    getAppliedCandidateSearch={getAppliedCandidateSearch}
                    candidateDetails={candidateDetailsDb}
                    setCandidateDetails={setCandidateDetailsDb}
                    radioValue={radioValueDb}
                    setRadioValue={setRadioValueDb}
                    setcandidateName={setcandidateNameDb}
                    candidateFeedbackDb={candidateFeedbackDb}
                    setCandidateFeedbackDb={setCandidateFeedbackDb}
                    setCandidateFeedback={setCandidateFeedbackDb}
                    handleCandidateFeedbackDb={handleCandidateFeedbackDb}
                    appliedCandidates={appliedCandidates}
                    setAppliedCandidates={setAppliedCandidates}
                    setClosingCandidateDetails={setClosingCandidateDetails}
                    openValue={openValue}
                    getCandidateDatas={getCandidateDatas}
                    setSendingCandidate={setSendingCandidate}
                    setJobListContent={setJobListContent}
                    setRoleStatus={setRoleStatus}
                    handleRedirectToCandidate={handleRedirectToCandidate}
                    job_closed_status_flag={job_closed_status_flag}
                />
            </div>

            {
                ['opened', 'paused']?.includes(openValue) ?
                    // openValue === 'opened' ?
                    <div className="modal-footer border-0 bg-transparent p-0 mx-4 mb-2 row align-items-center justify-content-between">
                        <div className="col-12 col-sm-6 m-0 mt-3 mt-sm-0 employer-home-card-one">
                            {remainingDays === 0 ?
                                <span className={"w-100 jobPost-FontSize job-rejected p-3 py-2 rounded"}>Expired</span>
                                :
                                <span className={" w-100 text-secondary jobPost-FontSize"}>{`Remaining Days: ${remainingDays}`}</span>
                            }
                        </div>

                    </div>

                    :
                    null
            }


            {/* Extended Validity  Modal*/}
            <div className="modal modal-lg fade" id={`extendedValidity${jobId}Modal`} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog  modal-dialog-centered">
                    <div className="modal-content py-2 px-3">
                        <div className="modal-header border-0 bg-transparent">
                            <h1 className="modal-title fs-5 fw-bold" id="staticBackdropLabel">Extend Your Job Post for an Additional 30 Days!</h1>
                            <button type="button" id={`extendedValidity${jobId}ModalCloseButton`} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <hr className='m-0 mx-3' />

                        <div className="modal-body px-3 pt-4 mb-3 w-100">
                            <div className="jobPost-FontSize text-secondary ps-4">
                                <span className=""><span className="fs-2 fw-bold text-dark">{country === "India" ? `${process.env.REACT_APP_EXTENDJOB_RUPEES}` : `$${process.env.REACT_APP_EXTENDJOB_DOLLARS}`}</span>/30days</span>
                                <p className="pb-3">For {cardTitle}</p>

                            </div>
                            <div>
                                <ul className="jobPost-FontSize mx-2 ps-2">
                                    <li className="list-unstyled mt-4 mb-3">
                                        <IoMdCheckmark className="mx-2 fs-5  brand-color" /> <span className="fw-bold">Extended Visibility: </span><span>Keep your job post visible to a wider audience for 30 days</span>
                                    </li>
                                    <li className="list-unstyled mb-3">
                                        <IoMdCheckmark className="mx-2 fs-5  brand-color" /> <span className="fw-bold">Reach More Candidates: </span><span>Maximize your chances of finding the right fit by keeping you post active</span>
                                    </li>
                                    <li className="list-unstyled mb-4">
                                        <IoMdCheckmark className="mx-2 fs-5  brand-color" /><span className="fw-bold">Seamless Process: </span><span>Simply make a payment to extend your job post, and it will remain live without any interruptions</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <span className='jobPost-FontSize text-secondary mx-3 pb-2'><IoIosInformationCircleOutline className='brand-color' /> Enhance your experience by upgrading to our Premium or Platinum plans. <a className='icon-link cursorPointer' onClick={handleExtendedValidity}>click here !</a></span>

                        <hr className='m-0 mx-3 text-dark' />

                        <div className="modal-footer border-0 bg-transparent row align-items-center justify-content-between my-3 ">
                            <div className="col-6 m-0">
                                <button type="button" className="btn w-100 btn-outline-secondary fw-bold" data-bs-dismiss="modal">Cancel</button>
                            </div>
                            <div className="col-6 m-0">
                                <button type="button" className="btn w-100 btn-brand-color fw-bold" onClick={(e) => extendValidityPost(e, jobId, `extendedValidity${jobId}ModalCloseButton`)} >Proceed</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


        </div >
    );
};

export default CardWithCard;



export const Fourcards = ({
    empIcon,
    profNum,
    empReview
}) => {
    return (
        <div className=" p-2 ">
            <div className="card rounded-2 py-3">
                {empReview === 'Viewed' || empReview === 'Applied' ?
                    <span className=" px-1 translate-middle badge empText nameColor fw-bold">
                        {empReview}
                    </span>
                    : null}
                {empReview === 'Not Reviewed' ?
                    <span className="px-1 translate-middle badge empTextNotReviewed nameColor fw-bold">
                        {empReview}
                    </span> : null

                }
                {empReview === 'Shortlisted' ?
                    <p className="px-1 translate-middle badge empTextShorlisted nameColor fw-bold">
                        {empReview}
                    </p> : null

                }

                <div className="d-flex w-100 align-items-center justify-content-evenly my-2 ">
                    <div className="empIcon d-flex align-items-center justify-content-center">
                        <span className="fs-4 z-2 ">{empIcon}</span>
                    </div>
                    <div>
                        <h5 className="card-title icon-number fw-normal m-0">{profNum}</h5>
                    </div>
                </div>
            </div>
        </div>
    )
}
